import React, { useState } from 'react';
import './header.css'
import Nav from '../common/nav-text';
import logo from '../../asserts/logo.png'
import { Link } from "react-router-dom";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };

    return ( <>
    <header className='header'>
        
        <div className='navv'>
<img className='logo' src={logo} alt="" />

<div className="mobile-toggle" onClick={toggleMenu}>
                    <span className={isMenuOpen ? "bar open" : "bar"}></span>
                    <span className={isMenuOpen ? "bar open" : "bar"}></span>
                    <span className={isMenuOpen ? "bar open" : "bar"}></span>
                </div>

                <div className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
                    <Link to="/" onClick={() => setIsMenuOpen(false)}>
                        <Nav navtext1="Home" s="navtext1" />
                    </Link>

                    <Link to="/projects" onClick={() => setIsMenuOpen(false)}>
                        <Nav navtext="Projects" s="navtext" />
                    </Link>

                    <Link to="/villas" onClick={() => setIsMenuOpen(false)}>
                        <Nav navtext="Villas" s="navtext" />
                    </Link>

                    <Link to="/*" onClick={() => setIsMenuOpen(false)}>
                        <Nav navtext="Apartment" s="navtext" />
                    </Link>

                    <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                        <button className='btn-log'>Sign in</button>
                    </Link>
                </div>


    </div>
    </header>
    
    </> );
}
 
export default Header;